import React, { useState } from "react";
import { showToast } from "../assets/util/showToast";
import { submitContactForm } from "../services/contact";

export default function ContactSection() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
    phone: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await submitContactForm(form);
      showToast(response.message, "success");
      setForm({ name: "", email: "", message: "", phone: "" });
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Something went wrong.";
      showToast(errorMessage, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="an-section spacing-small mt0 contact-section">
      <div className="an-title">
        <h2>HAI SĂ DISCUTĂM PROIECTUL TĂU</h2>
        <p>
          Spune-ne ce îți dorești pentru casa sau clădirea ta, iar echipa{" "}
          <strong>ASEMPERA</strong> îți va arăta cum tehnologia{" "}
          <strong>Loxone</strong> și
          <strong>
            {" "}
            experiența noastră de peste 20 de ani în automatizări
          </strong>{" "}
          pot aduce viață planurilor tale.
        </p>
      </div>
      <div className="an-content">
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="mb-3">
            <label className="form-label">Nume</label>
            <input
              name="name"
              type="text"
              className="form-control"
              placeholder="Nume"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Telefon</label>
            <input
              name="phone"
              type="text"
              className="form-control"
              placeholder="Telefon"
              value={form.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              name="email"
              type="email"
              className="form-control"
              placeholder="you@example.com"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Mesaj</label>
            <textarea
              name="message"
              className="form-control"
              rows={5}
              placeholder="Povestește-ne despre proiectul tău..."
              value={form.message}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="special-button button-special small w-full w-100"
            disabled={loading}
          >
            {loading ? "Se trimite..." : "Trimite mesajul"}
          </button>
        </form>
      </div>
    </div>
  );
}
